import { useState, useEffect, useCallback } from 'react'
import Logger from '@utils/log'
import { useNavigate } from 'react-router-dom'
import * as store from '@store'
import { useWireState } from '@forminator/react-wire'
import { useSearchParams } from 'react-router-dom'

const log = new Logger('AddPaymentCardDialogViewModel')

const AddPaymentCardDialogViewModel = (
    stripe,
    elements,
) => {
    
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()
    
    const [error, setError] = useState()
    const [loading, setLoading] = useState(true)
    const [message, setMessage] = useState()
    
    const [open, setOpen] = useWireState(store.addPaymentCardDialogOpen)
    
    const retrieveSetupIntent = useCallback(async (stripe, clientSecret) => {
        
        const res = await stripe.retrieveSetupIntent(clientSecret)
        
        // Inspect the SetupIntent `status` to indicate the status of the payment
        // to your customer.
        //
        // Some payment methods will [immediately succeed or fail][0] upon
        // confirmation, while others will first enter a `processing` state.
        //
        // [0]: https://stripe.com/docs/payments/payment-methods#payment-notification
        switch (res?.setupIntent?.status) {
            case 'succeeded':
                setMessage('Success! Your payment method has been saved.')
                break
            
            case 'processing':
                setMessage('Processing payment details. We\'ll update you when processing is complete.')
                break
            
            case 'requires_payment_method':
                // Redirect your user back to your payment page to attempt collecting
                // payment again
                setMessage('Failed to process payment details. Please try another payment method.')
                break
            default:
                setMessage('An unknown error occurred')
                break
        }
        
        setLoading(false)
        
    }, [])
    
    const handleSubmit = async e => {
        
        e.preventDefault()
        
        if (!stripe || !elements)
            return console.error('Stripe or Elements not loaded')
        
        setLoading(true)
        
        try {
            
            // Add the new card & redirect back to the billing page
            const res = await stripe.confirmSetup({
                elements,
                confirmParams: {
                    // location.host will include the port number
                    return_url: `${window.location.origin}/settings/billing`,
                    /* payment_method_data: {
                        billing_details: {
                            name: values.name,
                            address: {
                                line1: values.address,
                                postal_code: values.zip,
                            },
                        },
                    }, */
                },
            })
            
            // Stripe:
            // Your customer will be redirected to your `return_url`. For some payment
            // methods like iDEAL, your customer will be redirected to an intermediate
            // site first to authorize the payment, then redirected to the `return_url`.
            
            if (res.error) {
                setLoading(false)
                console.error('Stripe createPaymentMethod failed', res.error)
                return setError(res.error.message)
            }
            
        } catch (e) {
            
            setLoading(false)
            console.error('Stripe createPaymentMethod failed2', e)
            return setError(e.message)
            
        }
        
    }
    
    const handleModal = (redirect = false) => {
        
        setTimeout(() => setError(), 1000)
        
        if (!redirect)
            return setOpen(prev => !prev)
        
        navigate('/settings/billing', { replace: true })
        setTimeout(() => setOpen(prev => !prev), 500)
        
    }
    
    useEffect(() => {
        
        if (!stripe) return
        
        // Retrieve the "setup_intent_client_secret" query
        // parameter appended to your return_url by Stripe.js
        // const clientSecret = new URLSearchParams(window.location.search).get('setup_intent_client_secret')
        const clientSecret = searchParams.get('setup_intent_client_secret')
        
        if (!clientSecret?.length) {
            setLoading(false)
            return
        }
        
        retrieveSetupIntent(stripe,clientSecret)
            .then(() => setSearchParams(prev => {
                prev.delete('setup_intent')
                prev.delete('setup_intent_client_secret')
                return prev
            }))
            .catch(e => log.e('Failed to retrieve setup intent', e))
        
    }, [stripe, searchParams])
    
    return {
        
        // State
        open,
        setOpen,
        error,
        loading,
        message,
        setError,
        setLoading,
        setMessage,
        
        handleModal,
        handleSubmit,
        
    }
    
}

export default AddPaymentCardDialogViewModel
